import { load } from '@/util/router-utils.js'

export default [
  {
    path: 'settings',
    redirect: 'settings/mixers',
    component: load('app/client/farm/settings/Index'),
    children: [
      {
        path: 'mixers',
        component: load('app/client/farm/settings/mixers/Index')
      },
      {
        path: 'blanks',
        component: load('app/client/farm/settings/blanks/Index')
      }
    ]
  }
]
